// extracted by mini-css-extract-plugin
export default {"item":"PartnersItem_item__SO5LV","activeItem":"PartnersItem_activeItem__V6WLN"};